import { gql } from 'urql';

export default gql`
  mutation DeleteMeetingParticipants($company_user_ids: [Int!]!) {
    delete_meeting_participants(where: { company_user_id: { _in: $company_user_ids } }) {
      affected_rows
    }
  }
`;
